import { type ReactNode, useEffect } from 'react'
import { useCountdown } from '../../hooks/useCountdown'
import { feedback } from '../../lib/feedback'

interface Props {
  deadlineAt: number | null
  /** The room's own server clock. */
  serverNow: () => number
  children: ReactNode
  /** Match the board's corners. */
  shape?: 'rounded' | 'square'
}

/** "3… 2… 1… GO" over the board, with the lineup above the number. */
export function CountdownOverlay({ deadlineAt, serverNow, children, shape = 'rounded' }: Props) {
  const remaining = useCountdown(deadlineAt, serverNow)
  const seconds = remaining === null ? null : Math.max(1, Math.ceil(remaining / 1000))
  useEffect(() => {
    if (seconds !== null) feedback('countdown')
  }, [seconds])
  return (
    <div
      className={`pointer-events-none absolute inset-0 z-10 flex flex-col items-center justify-center gap-6 bg-slate-900/55 ${shape === 'rounded' ? 'rounded-3xl' : ''}`}
    >
      {children}
      <span
        key={seconds}
        className="animate-[ping_0.9s_ease-out] text-8xl font-black text-white drop-shadow-lg"
      >
        {seconds ?? 'GO'}
      </span>
    </div>
  )
}
